export var contractRepaymentStatusClassName;
(function (contractRepaymentStatusClassName) {
    contractRepaymentStatusClassName["INACTIVE"] = "status-inactive";
    contractRepaymentStatusClassName["REPAYING"] = "status-repaying";
    contractRepaymentStatusClassName["REPAID"] = "status-repaid";
    contractRepaymentStatusClassName["OVERDUE"] = "status-overdue";
})(contractRepaymentStatusClassName || (contractRepaymentStatusClassName = {}));
export var contractRepaymentStatus;
(function (contractRepaymentStatus) {
    contractRepaymentStatus["INACTIVE"] = "\u672A\u5F00\u59CB";
    contractRepaymentStatus["REPAYING"] = "\u8FD8\u6B3E\u4E2D";
    contractRepaymentStatus["REPAID"] = "\u5DF2\u8FD8\u6E05";
    contractRepaymentStatus["OVERDUE"] = "\u5DF2\u903E\u671F";
})(contractRepaymentStatus || (contractRepaymentStatus = {}));
